import { useEffect } from 'react';
import socket from '../useSocket';

// O socket é mantido vivo pelo próprio worker (singleton). O backend é a
// autoridade para detectar inatividade via engine.io ping/timeout — não
// existe heartbeat aplicacional aqui. Este componente apenas garante que o
// userId esteja registrado no worker, caso connect() tenha sido chamado
// sem ele em algum caminho legado.
const KeepSocketAlive = ({ userId }) => {
  useEffect(() => {
    if (userId) socket.setUserId(userId);
  }, [userId]);

  return null;
};

export default KeepSocketAlive;
